'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function inputValidate() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {

            //model -> view
            ngModel.$formatters.push(function (modelValue) {
                return modelValue / 100;
            });

            //view -> model
            ngModel.$parsers.push(function (viewValue) {
                viewValue = viewValue.replace(',', '.');
                return viewValue * 100;
            });
        }
    };
}

exports.default = inputValidate;


// WEBPACK FOOTER //
// ./client/app/common/directives/validate.directive.js